import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../../components_common/Button';
import SearchResults from '../../../components_common/SearchResults';
import { ViewResultBtnWrapper, TotalResultsWrapper } from './styled';

const mapStateToProps = ({ api: { total } }) => ({ total });

const TotalResultsBanner = ({ onClick, total }) => (
  <TotalResultsWrapper centered={!total}>
    <div>
      <SearchResults />
    </div>
    <ViewResultBtnWrapper>
      {total ? (
        <Button
          bkgColor="#000000"
          bold
          color="#FFFFFF"
          dataCy="button-view-results"
          height={44}
          onClick={onClick}
          title="VIEW RESULTS"
          width={180}
        />
      ) : null}
    </ViewResultBtnWrapper>
  </TotalResultsWrapper>
);

TotalResultsBanner.propTypes = {
  onClick: PropTypes.func,
  total: PropTypes.number
};

export default connect(mapStateToProps)(TotalResultsBanner);
